module.exports = __webpack_public_path__ + "static/media/ic_member.a7201f82.svg";